import { useCurrentWorkspace } from "@editor/contexts/WorkspaceDashboardContext";
import { workspaceRouter } from "@editor/trpc/workspace";

import { skipToken } from "@tanstack/react-query";

export const useHasWorkspaceReachedCustomDomainLimit = () => {
  const workspace = useCurrentWorkspace();

  const { data: customDomainsUsage } =
    workspaceRouter.getCustomDomainsUsage.useQuery(
      workspace?.id ? workspace.id : skipToken,
    );
  let hasWorkspaceReachedCustomDomainsLimit = true;

  if (customDomainsUsage) {
    if (customDomainsUsage.maximum === null) {
      hasWorkspaceReachedCustomDomainsLimit = false;
    } else {
      hasWorkspaceReachedCustomDomainsLimit =
        customDomainsUsage.current >= customDomainsUsage.maximum;
    }
  }

  return hasWorkspaceReachedCustomDomainsLimit;
};
